import * as React from "react";
import './Pick.css';
import '../components/Typograph.css';
import AppHeader from '../components/AppHeader';
import AppFooter from "../components/AppFooter";
import ImageRadioPicker from "../components/ImageRadioPicker";
import {BeslagType} from "../Model";
import oudhollandsImage from '../images/oudhollands.jpg'
import traditioneelImage from '../images/traditioneel.jpg'

export default class VersionPick extends React.Component {
    render() {
        return (
            <div className="page">
                <AppHeader title="Beslag uitvoering"/>

                <div className="page-middle">
                    <h1 className="pick-title">Welk beslagtype heeft u nodig?</h1>

                    <div className="pick-body">
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={BeslagType.OUDHOLLANDS}
                                          image={oudhollandsImage}/>

                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={BeslagType.TRADITIONEEL}
                                          image={traditioneelImage}/>
                    </div>
                </div>
                <AppFooter onNext={this.props.handleNextPage}
                           onPrevious={this.props.handlePreviousPage}
                           enableNext={this.props.currentValue}/>
            </div>
        );
    }
}
